export default __webpack_public_path__ + "media/images/arrow-right-06ca2d3f5917f58df5a070371963988b.svg";